<nav class="navigation-bar navigation-bar--top-border-white navigation-bar--background-style">
  <a [href]="skipLinkPath" class="screen-reader-only">{{ 'skiplink_to.main' | translate }}</a>
  <mat-toolbar class="toolbar responsive-row toolbar--no-padding" color="primary">
    <button [matMenuTriggerFor]="responsive_menu" class="responsive-menu-button" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
    <a
      class="toolbar__menu-item"
      [attr.aria-label]="'menu.label.dashboard' | translate"
      mat-icon-button
      role="link"
      title="{{ 'menu.label.dashboard' | translate }}"
      routerLink="/">
      <mat-icon>home</mat-icon>
    </a>
    @for (menuItem of menuItems | async; track menuItem.route) {
      <a
        [attr.aria-label]="menuItem.a11y | translate"
        [routerLink]="menuItem.route"
        class="toolbar__menu-item"
        mat-button
        role="link"
        routerLinkActive="toolbar__menu-item--active"
        title="{{ menuItem.a11y | translate }}"
        >{{ menuItem.i18n | translate }}
      </a>
    }
    <span class="spacer"></span>
    @if (isAuthenticated | async) {
      <portal-toolbar-account-menu
        class="toolbar__menu-item toolbar__menu-item--no-padding toolbar__menu-item--account" />
    }
  </mat-toolbar>

  <mat-menu #responsive_menu="matMenu">
    <a
      mat-menu-item
      [attr.aria-label]="'menu.label.dashboard' | translate"
      title="{{ 'menu.label.dashboard' | translate }}"
      role="menuitem"
      routerLink="/">
      {{ 'menu.label.dashboard' | translate }}
    </a>
    @for (menuItem of menuItems | async | responsiveFilter; track menuItem.route) {
      <div>
        @if (menuItem.itemType !== 'menu') {
          <a
            [attr.aria-label]="menuItem.a11y | translate"
            [routerLink]="menuItem.route"
            mat-menu-item
            role="menuitem"
            routerLinkActive="active"
            title="{{ menuItem.a11y | translate }}"
            >{{ menuItem.i18n | translate }}
          </a>
        }
      </div>
    }
  </mat-menu>
</nav>
